import 'inputmask';

/* eslint no-useless-escape: 0 */
class Form {

  constructor(el) {
    this.$form = $(el);
    this.$$fields = this.$form.find('input');
    this.$submitBtn = this.$form.find('[type="submit"]');
    this.$successMsg = this.$form.parent().find('.js-form-success');
    this.$closeBtn = this.$successMsg.find('.js-success-close');

    this.formIsValid = false;
  }

  init() {
    this.setEventListeners();
  }

  setEventListeners() {
    this.$$fields.each((_, field) => {
      $(field).on('blur', () => {
        $(field).data('touched', true);
        this.constructor.checkField(field);
      });

      $(field).on('input change', () => {
        this.constructor.checkField(field);
      });
    });

    this.$form.on('submit', event => {
      event.preventDefault();
      let allFieldsValid = true;

      this.$$fields.each((_, field) => {
        if (!this.constructor.validateField(field)) {
          allFieldsValid = false;
          $(field).data('touched', true);
          this.constructor.setInvalid(field);
        }
      });

      if (!allFieldsValid) {
        return;
      }

      this.$successMsg.fadeIn();
    });

    this.$closeBtn.on('click', event => {
      event.preventDefault();
      this.$successMsg.fadeOut();
      this.reset();

    });
  }

  reset() {
    this.$$fields.each((_, field) => {
      const $parent = $(field).closest('.js-field');
      $parent.removeClass('is-invalid is-valid');
      $(field).data('touched', false);
    });
  }




  static checkField(field) {
    const isTouched = $(field).data('touched');
    const fieldIsValid = this.validateField(field);

    if (!isTouched) return;

    if (fieldIsValid) {
      this.setValid(field);
    } else {
      this.setInvalid(field);
    }

  }

  static validateField(field) {
    const type = $(field).prop('type');
    const isDate = $(field).hasClass('js-date-field');
    const mask = $(field).data('mask');
    const value = $(field).val();

    if (type === 'text' && !isDate && !value.trim()) {
      return false;
    } if (type === 'email' && !this.emailIsValid(value)) {
      return false;
    } if (mask  && !this.maskIsValid(value, mask)) {
      return false;
    }



    return true;
  }


  static maskIsValid(value, mask) {
    return value.trim().length === mask.length;
  }

  static emailIsValid(value) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).toLowerCase());
  }

  static setValid(field) {
    const $parent = $(field).closest('.js-field');

    $parent.removeClass('is-invalid').addClass('is-valid');
  }

  static setInvalid(field) {
    const $parent = $(field).closest('.js-field');

    $parent.removeClass('is-valid').addClass('is-invalid');
  }

  static initAll() {
    $('.js-form').each((_, el) => {
      const form = new this(el);
      form.init();
    });
  }
}


export default Form;
